import { createPatchesInstances } from '@/lib/patches-setup';
import { adminGuard, authGuard } from '@/router/guards';
import { providePatchesContext } from '@dabble/patches/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);

// Create Patches instances upfront (before auth)
const { patches, sync } = createPatchesInstances();
providePatchesContext(app, patches, sync);

app.mount('#app');

router.beforeEach(authGuard);
router.beforeEach(adminGuard);
